@if (initialized && model) {
  <div>
    @if (step === 'choose-tariff-variant') {
      <app-tariff-select-variant
        [currentPlan]="model.currentPlan"
        [flatrates]="model.tariffList"
        (fairFlatSelected)="onTariffVariantSelected($event)"
        (fullFlatSelected)="onTariffVariantSelected($event)"
      (back)="resetWorkflow()"></app-tariff-select-variant>
    }
    @if (model?.subscription && step === 'choose-tariff') {
      <app-tariff-select
        (back)="onTariffSelectedBack()"
        [currentPlan]="model.currentPlan"
        [flatrates]="model.tariffList"
        [subscription]="model.subscription"
      (selected)="onTariffSelected($event)"></app-tariff-select>
    }
    @if (model?.subscription && model.tariffFlatOffer && step === 'delivery-date') {
      <app-tariff-place-order
        (back)="onTariffDeliveryDateBack()"
        [selectedTariff]="model.tariffFlatOffer.tariff_plan"
        [currentTariff]="model.subscription.tariffPlanDetail.currentPlan"
        (selected)="onTariffDeliveryDateSelected($event)"
      ></app-tariff-place-order>
    }
    @if (step === 'contact') {
      <app-select-invoice-contact
        [customer]="model.customer"
        [subscription]="model.subscription"
        (back)="onContactBack()"
        [historyBack]="false"
        (selected)="onContact($event)">
      </app-select-invoice-contact>
    }
    @if (step === 'invoice-address') {
      <app-invoice-address
        [historyBack]="false"
        (backEvent)="onInvoiceAddressBack()"
        [backLabel]="'app_back'"
        [company]="model.company"
        (next)="onInvoiceAddressFilled($event)"
      ></app-invoice-address>
    }
    @if (step === 'payment-method') {
      <app-payment-method [paymentMethod]="paymentMethod" [historyBack]="false" (backEvent)="onPaymentMethodBack()" [backLabel]="'app_back'" (next)="onPaymentMethodSelected($event)"></app-payment-method>
    }
    @if (model?.subscription && step === 'checkout-summary') {
      <app-checkout-one-summary
        backLabel="app_cancel"
        [historyBack]="false"
        [subscription]="model.subscription"
        (back)="onSummaryBack()"
        (buy)="onSummaryBuy()"
      ></app-checkout-one-summary>
    }
    @if (step === 'complete') {
      <app-partner-upgrade-offer-sent
        (next)="onComplete()"
        [customerEmail]="model.saleOrder.contact.email">
      </app-partner-upgrade-offer-sent>
    }
  </div>
}